import { Btn, H2, LI, P, SVG, UL } from "../../../../AbstractElements";
import { regularCustomersData } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";

const RegularCustomers = () => {
  return (
    <UL className="d-flex flex-row simple-list">
      {regularCustomersData.map((data, i) => (
        <LI key={i}>
          <H2>{data.amount}</H2>
          <P>{data.title}</P>
          <Btn className={`bg-light-${data.color} d-flex gap-1`}>
            <span className={`bg-light-${data.color}`}>
              <SVG iconId={data.icon} />
            </span>
            <span className={`font-${data.color} f-w-600`}>{data.percentage}</span>
          </Btn>
        </LI>
      ))}
    </UL>
  );
};

export default RegularCustomers;
